import React, { useState, useEffect } from "react";
import { db } from "../firebase";
import { auth } from "../firebase"; // For currentUser
import { getDoc, doc } from "firebase/firestore"; // For fetching user profile
import {
  collection,
  getDocs,
  query,
  addDoc,
  serverTimestamp
} from "firebase/firestore";
import emailjs from "emailjs-com";

function AskAnInsider() {
  const [company, setCompany] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [location, setLocation] = useState("");
  const [department, setDepartment] = useState("");
  const [username, setUsername] = useState("");
  const [question, setQuestion] = useState("");
  const [emails, setEmails] = useState([]);
  const [emailInput, setEmailInput] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [filteredCompanies, setFilteredCompanies] = useState([]);
  const [filteredCities, setFilteredCities] = useState([]);
  const [filteredStates, setFilteredStates] = useState([]);
  const [filteredUsernames, setFilteredUsernames] = useState([]);
  



  useEffect(() => {
    async function fetchFilters() {
      const reviewsRef = collection(db, "reviews");
      const usersRef = collection(db, "users");
      const querySnapshot = await getDocs(reviewsRef);
      const usersSnapshot = await getDocs(usersRef);

      const companies = new Set();
      const cities = new Set();
      const states = new Set();
      querySnapshot.forEach(doc => {
        companies.add(doc.data().company);
        cities.add(doc.data().location);
        states.add(doc.data().state);
      });

      const usernames = usersSnapshot.docs.map(doc => doc.data().username);

      setFilteredCompanies([...companies]);
      setFilteredCities([...cities]);
      setFilteredStates([...states]);
      setFilteredUsernames(usernames);
    }

    fetchFilters();
  }, []);

  const handleEmailKeyDown = (e) => {
    if (e.key === "Enter" && emailInput.trim()) {
      e.preventDefault();
      setEmails(prev => [...prev, emailInput.trim()]);
      setEmailInput("");
    }
  };

  const removeEmail = (index) => {
    setEmails(prev => prev.filter((_, i) => i !== index));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess(false);

     // ✅ Prevent submitting empty question
  if (!question.trim()) {
    setError("Please enter a question before submitting.");
    return;
  }

    try {
      let finalUsername = "Anonymous";

      if (auth.currentUser) {
        const userRef = doc(db, "users", auth.currentUser.uid);
        const userSnap = await getDoc(userRef);
        if (userSnap.exists()) {
          finalUsername = userSnap.data().username || "Anonymous";
        }
      }
      const docRef = await addDoc(collection(db, "reviews"), {
  company: company || "N/A",
  state: state || "N/A",
  city: city || "N/A",
  location: location || "N/A",
  department: department || "N/A",
  username: finalUsername,
  userId: auth.currentUser?.uid || null,
  comments: question,
  createdAt: serverTimestamp(),
  ratings: {},
  responses: [],
  isQuestion: true,
  likes: 0 
});


      const postUrl = `${window.location.origin}/post/${docRef.id}`;

      for (let email of emails) {
        await emailjs.send("service_adwbhlm", "template_240tet8", {
          email: email, // new template uses "email"
          name: "VibeScanTeam",
          username: finalUsername,
          company,
          city,
          state,
          preview: question.slice(0, 200),
          postUrl
        }, "fiwBM11ZCGFFnqPqR");
      }

      setSuccess(true);
      setCompany("");
      setState("");
      setCity("");
      setLocation("");
      setDepartment("");
      setUsername("");
      setQuestion("");
      setEmails([]);
    } catch (err) {
      console.error("EmailJS send error:", err);
      setError("Failed to submit question. Please try again.");
    }
  };


  
  return (
  <div style={{ position: "relative", minHeight: "100vh" }}>
  {/* 🔲 Background Layer */}
  <div
    style={{
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "#d6eaff",  // <- changed here
      zIndex: 0
    }}
  />

    {/* 🔳 Foreground Content */}
    <div
      style={{
        position: "relative",
        zIndex: 1,
        maxWidth: "500px",
        margin: "auto",
        padding: "20px",
        backgroundColor: "rgba(255, 255, 255, 0.6)",
        borderRadius: "8px"
      }}
    >
      <div style={{ maxWidth: "500px", marginTop: "0px", margin: "auto", padding: "0px", textAlign: "center"  }}>
        <h2>Ask an Insider</h2>
        {error && <p style={{ color: "red" }}>{error}</p>}
        {success && <p style={{ color: "green" }}>Question submitted successfully!</p>}
      </div>

      <form
        onSubmit={handleSubmit}
        onKeyDown={(e) => {
          if (e.key === "Enter" && e.target.type !== "email") {
            e.preventDefault();
          }
        }}
        style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}
      >
        <label>Company Name</label>
        <input type="text" value={company} onChange={(e) => setCompany(e.target.value)} list="company-list" style={inputStyle} />
        <datalist id="company-list">
          {filteredCompanies.map((comp, index) => <option key={index} value={comp} />)}
        </datalist>

        <label>State</label>
        <input type="text" value={state} onChange={(e) => setState(e.target.value)} list="state-list" style={inputStyle} />
        <datalist id="state-list">
          {filteredStates.map((st, index) => <option key={index} value={st} />)}
        </datalist>

        <label>City</label>
        <input type="text" value={city} onChange={(e) => setCity(e.target.value)} list="city-list" style={inputStyle} />
        <datalist id="city-list">
          {filteredCities.map((c, index) => <option key={index} value={c} />)}
        </datalist>

        <label>Location (Street Name, Store Number, etc.)</label>
        <input type="text" value={location} onChange={(e) => setLocation(e.target.value)} style={inputStyle} />

        <label>Department</label>
        <input type="text" value={department} onChange={(e) => setDepartment(e.target.value)} style={inputStyle} />

        <label>Enter your question</label>
        <textarea value={question} onChange={(e) => setQuestion(e.target.value)} style={{ ...inputStyle, minHeight: "50px" }}></textarea>

        <label style={{ display: "flex", alignItems: "center", gap: "6px" }}>
  Email(s) of employees to contact
  <span
    style={{
      cursor: "pointer",
      border: "1px solid #ccc",
      borderRadius: "50%",
      width: "18px",
      height: "18px",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "12px",
      backgroundColor: "#007BFF",
    }}
    title="Enter the email address of the employee(s) you want to contact. They’ll receive your question and a link to respond anonymously. Press Enter after each email to confirm."
  >
    ?
  </span>
</label>

<input
  type="email"
  placeholder="Press Enter after each email"
  value={emailInput}
  onChange={(e) => setEmailInput(e.target.value)}
  onKeyDown={handleEmailKeyDown}
  style={{
    width: "100%",
    padding: "10px",
    fontSize: "14px",
    border: "1px solid #ccc",
    borderRadius: "4px",
    marginBottom: "10px"
  }}
/>

<div style={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>
  {emails.map((email, index) => (
    <span key={index} style={{ backgroundColor: "#eee", padding: "5px", borderRadius: "5px" }}>
      {email}
      <button onClick={() => removeEmail(index)} style={{ marginLeft: "5px", cursor: "pointer" }}>x</button>
    </span>
  ))}
</div>


	{error && <p style={{ color: "red" }}>{error}</p>}
        {success && <p style={{ color: "green" }}>Question submitted successfully!</p>}

        <button type="submit" style={{ marginTop: "10px", padding: "10px", backgroundColor: "#007BFF", color: "white", border: "none", cursor: "pointer" }}>
          Submit
        </button>
      </form>
    </div>
  </div>
);
}

const inputStyle = {
  border: "none",
  borderBottom: "1px solid #ccc",
  outline: "none",
  width: "100%",
  padding: "5px",
  marginBottom: "10px"
};



export default AskAnInsider;
